export async function relocateWithTagUseCase(data, relocationRepository) {
    const result = await relocationRepository.relocate_with_tag(data);

    result.data.success.arguments.forEach(x => {
        x = new relocationRepository.model(x);

        if (!x.isValid()) {
            throw new Error("Reubicación inválida");
        }
    })

    return result;
}